export enum HgSessionStorageKey {
  SESSION_ID = 'sessionId',
}
